import CitiesPage from "../pages/Cities/CitiesPage";
import CitiesNewsPage from "../pages/City/CitiesNewsPage";
import CityDetailPage from "../pages/City/CityDetailPage";
import ESim from "../pages/ESim/ESim";
import ESimsPage from "../pages/ESim/ESimsPage";
import Event from "../pages/Event/Event";
import EventList from "../pages/EventList/EventList";
import GuideTour from "../pages/GuideTour/GuideTour";
import GuideToursPage from "../pages/GuideTour/GuideToursPage";
import HomePage from "../pages/HomePage/HomePage";
import SearchPage from "../pages/HomePage/SearchPage";
import HotelInquiry from "../pages/HotelInquiry/HotelInquiry";
import { JpPayRedirectPaymentPage } from "../pages/JpPayRedirectPaymentPage";
import MorePage from "../pages/More/MorePage";
import MusicalDetail from "../pages/MusicalDetail/MusicalDetail";
import MusicalsPage from "../pages/MusicalDetail/MusicalsPage";
import SelectTicket from "../pages/MyBooking/SelectTicket";
import DetailInquiry from "../pages/MyInquiry/DetailInquiry";
import MyInquiry from "../pages/MyInquiry/MyInquiry";
import PostInquiry from "../pages/MyInquiry/PostInquiry";
import MyPage from "../pages/MyPage/MyPage";
import OAuthCallback from "../pages/OAuthCallback";
import Pass from "../pages/Pass/Pass";
import PassIntroduction from "../pages/Pass/PassIntroduction";
import PassPage from "../pages/Pass/PassPage";
import PaymentCallback from "../pages/PaymentCallback";
import { ResetPassword } from "../pages/ResetPassword/ResetPassword";
import CartPage from "../pages/ShoppingCart/CartPage";
import OrderProduct from "../pages/ShoppingCart/OrderProduct";
import { TermPolicyPage } from "../pages/TermPolicy/TermPolicyPage";
import Ticket from "../pages/Ticket/Ticket";
import BookingInfo from "../pages/TicketCheck/BookingInfo";
import TicketCheck from "../pages/TicketCheck/TicketCheck";
import TicketBookingPage from "../pages/TicketPage/TicketBookingPage";
import TicketBookingSuccessPage from "../pages/TicketPage/TicketBookingSuccessPage";
import TicketPage from "../pages/TicketPage/TicketPage";

export const routes = [
  { path: "/", component: HomePage },
  { path: "/home", component: HomePage },
  { path: "/more", component: MorePage },
  { path: "/pass/:id", component: Pass },
  { path: "/pass/introduction", component: PassIntroduction },
  { path: "/tickets", component: TicketPage },
  { path: "/ticket-check", component: TicketCheck },
  { path: "/ticket-check/booking-info/:no", component: BookingInfo },
  { path: "/tickets/:id", component: Ticket },
  { path: "/tickets/booking", component: TicketBookingPage },
  { path: "/tickets/booking-success", component: TicketBookingSuccessPage },
  { path: "/mypage/:tab?", component: MyPage, isPrivate: true },
  { path: "/musicals", component: MusicalsPage },
  { path: "/musicals/:id", component: MusicalDetail },
  { path: "/guide-tours", component: GuideToursPage },
  { path: "/guide-tours/:id", component: GuideTour },
  { path: "/e-sims", component: ESimsPage },
  { path: "/pass", component: PassPage },
  { path: "/home/search", component: SearchPage },
  { path: "/e-sims/:id", component: ESim },
  { path: "/ticket/:id", component: Ticket },
  { path: "/redirect/payment", component: JpPayRedirectPaymentPage },
  // { path: "/shopping-cart", component: ShoppingCart },
  // { path: "/shopping-cart/order", component: OrderProduct },
  { path: "/shopping-cart", component: OrderProduct },
  { path: "/ticket-check/booking-info/select-ticket", component: SelectTicket },
  { path: "/my-inquiry", component: MyInquiry },
  { path: "/detail-inquiry/:id", component: DetailInquiry },
  { path: "/post-inquiry", component: PostInquiry },
  { path: "/hotel-inquiry", component: HotelInquiry },
  { path: "/p/termPolicy/:type", component: TermPolicyPage },

  { path: "/events", component: EventList },
  { path: "/events/:id", component: Event },
  { path: "/oauth/:socialLogin", component: OAuthCallback },
  { path: "/payment/callback", component: PaymentCallback },
  { path: "/cart", component: CartPage },
  { path: "/cities", component: CitiesPage },
  { path: "/cities/:id", component: CityDetailPage },
  { path: "/cities/:id/news/:newsId", component: CitiesNewsPage },
  {
    path: "/reset-password",
    component: ResetPassword,
  },
];
